import {
  REQUEST_A_SIGNUP_LINK_START,
  REQUEST_A_SIGNUP_LINK_COMPLETE,
  REQUEST_A_SIGNUP_LINK_ERROR,
  VERIFY_PHONE_NUMBER_START,
  VERIFY_PHONE_NUMBER_COMPLETE,
  VERIFY_PHONE_NUMBER_ERROR,
  VERIFY_PHONE_NUMBER_OTP_START,
  VERIFY_PHONE_NUMBER_OTP_COMPLETE,
  VERIFY_PHONE_NUMBER_OTP_ERROR,
  CREATE_PASSWORD_START,
  CREATE_PASSWORD_COMPLETE,
  CREATE_PASSWORD_ERROR,
  VERIFY_EMAIL_START,
  VERIFY_EMAIL_COMPLETE,
  VERIFY_EMAIL_ERROR,
  CLEAR_SIGNUP_ERROR,
} from './actions';
import {LOGOUT} from '../login/actions';

let initialState = {
  requestSignUpLinkStarted: false,
  requestSignUpLinkError: undefined,
  isVerifyPhoneNumberStarted: false,
  verifyPhoneNumberError: undefined,
  isVerifyPhoneNumberOtpStarted: false,
  verifyPhoneNumberOtpError: undefined,
  isCreatePasswordStarted: false,
  createPsswordError: undefined,
  isVerifyEmailStarted: false,
  verifyEmailError: undefined,
};

const reducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case REQUEST_A_SIGNUP_LINK_START:
      return {
        ...state,
        requestSignUpLinkStarted: true,
        requestSignUpLinkError: undefined,
      };
    case REQUEST_A_SIGNUP_LINK_COMPLETE:
      return {
        ...state,
        requestSignUpLinkStarted: false,
        requestSignUpLinkError: undefined,
      };
    case REQUEST_A_SIGNUP_LINK_ERROR:
      return {
        ...state,
        requestSignUpLinkError: payload.error,
        requestSignUpLinkStarted: false,
      };
    case VERIFY_PHONE_NUMBER_START:
      return {
        ...state,
        isVerifyPhoneNumberStarted: true,
        verifyPhoneNumberError: undefined,
        phoneNumberToken: undefined,
      };
    case VERIFY_PHONE_NUMBER_COMPLETE:
      return {
        ...state,
        isVerifyPhoneNumberStarted: false,
        verifyPhoneNumberError: undefined,
        phoneNumberToken: payload.data,
      };
    case VERIFY_PHONE_NUMBER_ERROR:
      return {
        ...state,
        verifyPhoneNumberError: payload.error,
        isVerifyPhoneNumberStarted: false,
        phoneNumberToken: undefined,
      };
    case VERIFY_PHONE_NUMBER_OTP_START:
      return {
        ...state,
        isVerifyPhoneNumberOtpStarted: true,
        verifyPhoneNumberOtpError: undefined,
        otpToken: undefined,
      };
    case VERIFY_PHONE_NUMBER_OTP_COMPLETE:
      return {
        ...state,
        isVerifyPhoneNumberOtpStarted: false,
        verifyPhoneNumberOtpError: undefined,
        otpToken: payload.data,
      };
    case VERIFY_PHONE_NUMBER_OTP_ERROR:
      return {
        ...state,
        verifyPhoneNumberOtpError: payload.error,
        isVerifyPhoneNumberOtpStarted: false,
        otpToken: undefined,
      };
    case CREATE_PASSWORD_START:
      return {
        ...state,
        isCreatePasswordStarted: true,
        createPsswordError: undefined,
      };
    case CREATE_PASSWORD_COMPLETE:
      return {
        ...state,
        isCreatePasswordStarted: false,
        createPsswordError: undefined,
      };
    case CREATE_PASSWORD_ERROR:
      return {
        ...state,
        createPsswordError: payload.error,
        isCreatePasswordStarted: false,
      };
    case VERIFY_EMAIL_START:
      return {
        ...state,
        isVerifyEmailStarted: true,
        verifyEmailError: undefined,
        emailToken: undefined,
      };
    case VERIFY_EMAIL_COMPLETE:
      return {
        ...state,
        isVerifyEmailStarted: false,
        verifyEmailError: undefined,
        emailToken: payload.data,
      };
    case VERIFY_EMAIL_ERROR:
      return {
        ...state,
        verifyEmailError: payload.error,
        isVerifyEmailStarted: false,
        emailToken: undefined,
      };
    case CLEAR_SIGNUP_ERROR:
      return {
        ...state,
        verifyEmailError: undefined,
        createPsswordError: undefined,
        verifyPhoneNumberOtpError: undefined,
        verifyPhoneNumberError: undefined,
        requestSignUpLinkError: undefined,
        isVerifyEmailStarted: false,
        isCreatePasswordStarted: false,
        isVerifyPhoneNumberOtpStarted: false,
        isVerifyPhoneNumberStarted: false,
      };
    case LOGOUT: 
      return initialState;
    default:
      return state;
  }
};

export default reducer;
